import script from "./dealer.vue?vue&type=script&setup=true&lang=js"
export * from "./dealer.vue?vue&type=script&setup=true&lang=js"

import "./dealer.vue?vue&type=style&index=0&id=0b8fd0be&lang=less&scoped=true"

import exportComponent from "D:\\workspace\\payment-system-merchant\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b8fd0be"]])

export default __exports__